import { postMethod, post, get } from '@/axios/index'
const api = '/articleRecord'
export const favor = (p) => postMethod(api + '/favor', p)
export const doMark = (p) => postMethod(api + '/doMark', p)
export const doArticleRecord = (p) => postMethod(api + '/record', p)
export const getCommentPage = (p) => get(api + '/commentPage', p)
export const getDeleteComment = (p) => get(api + '/deleteComment', p)
export const postComment = (p) => post(api + '/comment', p)
const api1 = '/mini'
export const articleInfor = (p) => postMethod(api1 + '/article/info', p)
export const guestArticle = (p) => postMethod(api1 + '/login/guestArticle', p)
export const readList = (p) => post(api1 + '/article/readList', p)
export const turnArticle = (p) => get(api1 + '/turnArticle', p)
export const getHistoryArticles = (p) => get(api1 + '/historyArticles2', p)
const api2 = '/miniReport'
export const doReportRecord = (p) => postMethod(api2 + '/record', p)
